import CloseIcon from "@mui/icons-material/Close";
import { useMountEffect } from "@react-hookz/web";
import React, { Suspense, useState } from "react";
import { useSdkContext } from "~/components/contexts";
import { useIsNotificationSupported } from "./hooks";
var ChevronLeftIcon = function ChevronLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29 5.988 7 11.404 6.369 12 0 5.988 6.369 0 7 .597l-5.71 5.39Z",
    fill: "#4585FF"
  }));
};
ChevronLeftIcon.defaultProps = {
  width: "7",
  height: "12",
  viewBox: "0 0 7 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var NotificationIcon = function NotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12c-.594 0-1.078-.181-1.453-.543a1.936 1.936 0 0 1-.586-1.04H1.22c-.313 0-.594-.11-.844-.33A1.057 1.057 0 0 1 0 9.26v-.166L.141 9A6.121 6.121 0 0 0 1.992 6.66c.422-.913.633-1.913.633-3 0-.755.25-1.385.75-1.89a3.69 3.69 0 0 1 1.383-.684 1.15 1.15 0 0 1 .399-.78C5.39.103 5.672 0 6 0c.328 0 .61.103.844.307.234.205.367.465.398.78.563.141 1.024.37 1.383.685.5.504.75 1.134.75 1.89 0 1.086.211 2.078.633 2.976A6.08 6.08 0 0 0 11.859 9l.141.094v.166c0 .3-.125.575-.375.826-.25.221-.531.331-.843.331H8.039c-.078.394-.273.74-.586 1.04C7.078 11.819 6.594 12 6 12Z",
    fill: "#fff"
  }));
};
NotificationIcon.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { NotificationInstruction } from "./notification-instruction";
import { NotificationList } from "./notification-list";
import { NotificationSetting } from "./notification-setting";
import { AlertButton, AlertTitle, BackButton, Header, InstructionCloseButton, InstructionContainer, ListContainer, Loading, NotificationTitle, SettingContainer } from "./styles";
export const NotificationPanel = ({
  notificationListQuery
}) => {
  const [currentTab, setCurrentTab] = useState("list");
  const {
    isNotificationSupported
  } = useIsNotificationSupported();
  const {
    handleTrackGA,
    handleTrackGA4
  } = useSdkContext();
  useMountEffect(() => {
    handleTrackGA({
      action: "Article recommend/Notification/Impression",
      category: "Article recommend - Notification centre",
      label: ""
    });
    handleTrackGA4({
      action: "imp",
      category: "noticenter",
      customized_parameters: undefined,
      subcategory: ""
    });
  });
  switch (currentTab) {
    case "list":
      return /*#__PURE__*/React.createElement(ListContainer, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(NotificationTitle, null, "Notifications"), /*#__PURE__*/React.createElement(AlertButton, {
        onClick: () => {
          handleTrackGA({
            action: "My Account/Overlay/Notification/Alerts/Click",
            category: "My Account",
            label: ""
          });
          setCurrentTab("setting");
        }
      }, /*#__PURE__*/React.createElement(NotificationIcon, null), "Alerts")), /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, {
          color: "inherit"
        })
      }, notificationListQuery && /*#__PURE__*/React.createElement(NotificationList, {
        queryReference: notificationListQuery
      })));
    case "setting":
      return /*#__PURE__*/React.createElement(SettingContainer, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(BackButton, {
        onClick: () => setCurrentTab("list")
      }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
        fontSize: "inherit"
      })), /*#__PURE__*/React.createElement(AlertTitle, null, "Alerts")), /*#__PURE__*/React.createElement(NotificationSetting, {
        isNotificationSupported: isNotificationSupported,
        onPermissionDenied: () => setCurrentTab("instructions")
      }));
    case "instructions":
      return /*#__PURE__*/React.createElement(InstructionContainer, null, /*#__PURE__*/React.createElement(InstructionCloseButton, {
        "aria-label": "close",
        onClick: () => setCurrentTab("setting")
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        color: "inherit"
      })), /*#__PURE__*/React.createElement(NotificationInstruction, null));
  }
};
NotificationPanel.displayName = "NotificationPanel";